<template>
  <div class="image-list" v-loading="loadingState === 'loading'">
    <template v-if="loadingState === 'done'">
      <div class="image-list__header header">
        <div class="header__left">
          我的图片
        </div>
        <div class="header__right" v-if="images && images.length">
          <div class="button button--primary" @click="goUpload()">添加本地图片</div>
        </div>
      </div>
      <div class="image-list__content" v-bar>
        <div>
          <ul v-if="images && images.length">
            <li v-for="(item, i) in images" :key="i" @click="selectImage(item)">
              <img :src="$handleAssetsUrl(item.url)" :alt="item.title">
            </li>
          </ul>
          <div v-else>
            <div style="margin-bottom: 50px;margin-top: 30px;">这里还没有你上传的图片哦~</div>
            <div class="button button--primary" @click="goUpload()">添加本地图片</div>
          </div>
        </div>
      </div>
    </template>

    <label ref="uploadTrigger" for="imageFrame"></label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['isPopupShow'],
  data () {
    return {
      images: [],
      api: '/api/common/material/pic?sOfPage=10000&fPage=10000&pIndex=1',
      // api: '/api/common/material/pic',
      loadingState: '',
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
    ])
  },
  created () {
    this.$bus.on('collectPersonal_vue', () => {
      if (this.isPopupShow) {
        this.loadData()
          .then((arr) => {
            if (arr && arr[0]) {
              this.selectImage(arr[0], {
                willClosePopup: false
              });
            }
          })
      }
    })
  },
  methods: {
    async loadData () {
      let {data: staticImages} = await this.loadStaticImages();
      console.log({
        staticImages
      });
      if (!staticImages || !staticImages.length) {
        return;
      }
      this.images = staticImages
      // this.images.push(...staticImages);
      return staticImages
    },
    loadStaticImages () {
      this.loadingState = 'loading';
      return new Promise((resolve) => {
        this.$http.get(this.api)
          .then(({data: resData} = {}) => {
            let {data, code} = resData;
            resolve(resData);
            this.loadingState = 'done';
          })
          .catch((err) => {
            console.warn(err)
            this.loadingState = 'done';
          })
      })
    },
    selectImage (item, {willClosePopup = true} = {}) {
      const sprite = this.TOOL.selectedSprite[0];
      let hasPic = sprite.picData.picSize;
      let isResetPosition = !hasPic;
      sprite.loadPic({
        url: this.$handleAssetsUrl(item.url),
        fileType: item.fileType,
        resourceId: item.id,
      }, isResetPosition, true);

      if (willClosePopup) {
        this.$emit('closePopup');
      }

      this.$bus.emit('FeaturesPop_close_vue', {
        type: 1,
        name: 'frameWidget'
      })
    },
    goUpload () {
      this.$refs.uploadTrigger.click();
    }
  }
}
</script>

<style lang="scss" scoped>
.image-list {
  min-height: 454px;
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 6px;
    padding-bottom: 20px;
  }
  &__content {
    height: 454px;

    & > div > ul {
      padding-bottom: 20px;
      padding-left: 15px;
      text-align: left;
    }

    & li {
      display: inline-block;
      position: relative;
      box-sizing: border-box;
      width: 110px;
      height: 62px;
      border: solid #eaeaf5 2px;
      border-radius: 4px;

      &:nth-of-type(2n) {
        margin-left: 10px;
      }

      &:hover {
        border-color: #5778fb;
      }

      & > img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}

.button {
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/selectFrameImage/content.vue